
import React, { useState, useEffect, useContext } from 'react';
import { ListView, PullToRefresh } from 'antd-mobile';
import SearchWrapper from '@/components/searchWrapper'
import ListBox from '@/components/listBox';
import Filter from '@/components/filter'
import { list, info } from '@/services/saas/liveChannel';
import { MyContext } from '@/utils/contextManager';
import { useHistory } from 'react-router';
import sysConfig from '@/sysConfig';
const { preRouteUrl } = sysConfig;

const PageSize = 4;

const ListWrap = (props) => {
  return <ul className="conference-list">{props.children}</ul>;
}

const ConferenceList = (props) => {

    const history = useHistory();

    const { config = {} } = props;

    const { replayable } = config;

    const defaultOptions = {
      size: PageSize,
      replayable,
      isPublish: 1,
      // timeBetween: 1
    }

    const source = new ListView.DataSource({
      getRowData: (dataBlob, sectionID, rowID) => {
        return dataBlob[sectionID][rowID];
      },
      rowHasChanged: (row1, row2) => row1 !== row2,
    });

    const [hasMore, setHasMore] = useState(true);

    const [pageIndex, setIndex] = useState(0);

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [draging, setDraging] = useState(false);

    const [dataSource, setDataSouce] = useState(source);
    // 筛选框的字段
    const [name, setSearchName] = useState("");

    const [filter, setFilter] = useState({});

    const { setFilters } = useContext(MyContext);

    const getData = async (page) => {
      setLoading(true);
      if (!page) {
          page = 1;
      }
      const { startTime, endTime } = filter;
      const timeBetween = replayable === '1' ? null : 1;
      const param = {
        ...defaultOptions,
        startTime,
        endTime,
        timeBetween,
        activityName: name,
        current: page,
      };
      const resp = await list(param);
      if (!resp.success) {
        return ;
      }
      let datas = [];
      if (page !== 1) {
        datas = [...data];
      }
      datas = [
        ...datas,
        ...resp.data.records.map(item => {
          return ({
            id:item.id,
            coverUrl:item.coverUrl,
            time: item.startTime,
            status: 1,
            title: item.activityName,
            schoolName: item.lectureDept,
            teacherName: item.lecturer,
            gradeName: '',
            subjectName: '',
          })
        })
      ]

      setLoading(false);
      setDraging(false);
      setData(datas);
      setDataSouce(dataSource.cloneWithRows(datas));
      setHasMore(resp.data.current < resp.data.pages);
      setIndex(page);
    }

    const onEndReached = () => {
      if (!loading && hasMore) {
        getData(pageIndex + 1);
      }
    };

    const rowClick = async (id) => {
      const resp = await info({ id });
      if (!resp.success) {
        return ;
      }
      const { replayable } = resp.data;
      switch (replayable) {
        case '0':
          history.push(`${preRouteUrl}/livePlay/liveChannel/${id}`);
          break;
        case '1':
          history.push(`${preRouteUrl}/livePlayback/liveChannel/${id}`);
          break;
        default:
          break;
      }
    }

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, name]);

    useEffect(() => {
      setFilters(
        <Filter
          data={[]}
          handleSearch={(item) => {
            setFilter(item);
          }}
        >
        </Filter>
      );
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const row = (rowData, sectionID, rowID) => {
      const { id, time, status, title, schoolName, teacherName, gradeName, subjectName, personNumber, coverUrl } = rowData;
      return (
        <ListBox
          id={id}
          time={time}
          status={status}
          title={title}
          schoolName={schoolName}
          teacherName={teacherName}
          gradeName={gradeName}
          subjectName={subjectName}
          personNumber={personNumber}
          coverUrl={coverUrl}
          onClick={rowClick}
      ></ListBox>
      )
    }
    return (
        <ListView
        dataSource={dataSource}
        renderHeader={() => (<SearchWrapper onChange={setSearchName}></SearchWrapper>)}
        renderFooter={() => (
          <div style={{ padding: 30, textAlign: 'center' }}>
            {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="conference-list-wrap"
        pageSize={PageSize}
        scrollRenderAheadDistance={500}
        onEndReached={onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            refreshing={draging}
            onRefresh={() => {
              setDraging();
              getData();
            }
          }
        />
        }
      />
    )
}

export default ConferenceList;
